<template>
    <div class="wrapper">
    <div class="search_wrap">
        <el-form :model="queryParams" ref="form" :inline="true" size="mini">
        <el-form-item label="设备名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.deviceName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.deviceNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="用户昵称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.nickname"
            placeholder="请输入"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="用户手机号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否打印">
            <el-select v-model="queryParams.isPrint" placeholder="请选择" clearable>
            <el-option
              v-for="item in yesOrNo"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打印时间">
            <el-date-picker
                @change="dateChange"
                v-model="selectDate"
                type="datetimerange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="是否检查">
            <el-select v-model="queryParams.inspect" placeholder="请选择" clearable>
            <el-option
              v-for="item in yesOrNo"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有问题">
            <el-select v-model="queryParams.problem" placeholder="请选择" clearable>
            <el-option
              v-for="item in yesOrNo"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="溯源码">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParams.id"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否需要回收袋">
            <el-select v-model="queryParams.needRecyclingBag" placeholder="请选择" clearable>
            <el-option
              v-for="item in yesOrNo"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
      <el-table
      :data="list"
      ref="multipleTable"
      stripe
      style="width: 100%">
      <el-table-column
        prop="deviceName"
        label="设备名称"
        width="160">
        <template slot-scope="scope">
           {{ scope.row.deviceName}}
        </template>
      </el-table-column>
      <el-table-column
        prop="deviceNo"
        label="设备号"
        width="160">
        <template slot-scope="scope">
           {{ scope.row.deviceNo}}
        </template>
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="用户昵称"
        width="130">
        <template slot-scope="scope">
           {{ scope.row.nickname}}
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="用户手机号"
        width="160">
        <template slot-scope="scope">
           {{ scope.row.phone}}
        </template>
      </el-table-column>
      <el-table-column
        prop="isPrint"
        label="是否打印"
        width="100">
        <template slot-scope="scope">
           {{ setYesOrNo(scope.row.isPrint)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="printTime"
        label="打印时间"
        width="180">
        <template slot-scope="scope">
           {{ scope.row.printTime}}
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="溯源码"
        width="100">
        <template slot-scope="scope">
           {{ scope.row.id}}
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="回收单号"
        width="180">
        <template slot-scope="scope">
           {{ scope.row.orderNo}}
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        label="业务类型"
        width="100">
        <template slot-scope="scope">
           {{ setType(scope.row.type)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="inspect"
        label="是否检查"
        width="100">
        <template slot-scope="scope">
           {{ setYesOrNo(scope.row.inspect)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="problem"
        label="是否有问题"
        width="90">
        <template slot-scope="scope">
           {{ setYesOrNo(scope.row.problem)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="problem"
        label="是否需要回收袋"
        width="160">
        <template slot-scope="scope">
           {{ setYesOrNo(scope.row.needRecyclingBag)}}
        </template>
      </el-table-column>
      </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageNo"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    </div>
  </template>
  
  <script>
  import {getTraceCodeRecordList} from '@/api/traceabilityCode';

  export default {    
   // components: { 'el-table': ElTable },  
    data() {
      return {
       list:[],
       total: 0,
       pageSizes: [15, 20, 30, 40, 100, 200],
       pageSize: 15,
       pageNo: 1,
       yesOrNo: [{id: 1, value: '是'},{id: 0, value: '否'}],
       types: [{id: 1, value: '可回收物'}, {id: 2, value: '商城订单'}],
       selectDate: undefined,
       queryParams: {
        deviceName: undefined,
        deviceNo: undefined,
        nickname: undefined,
        phone: undefined,
        printTimeStart: undefined,
        printTimeEnd: undefined,
        inspect: undefined,
        problem: undefined,
        isPrint: undefined,
        id: undefined,
        needRecyclingBag: undefined,
       },
      };
    },
    watch: {},
    computed: {},
    mounted() {
      this.getDataList();
    },
    methods: {
    dateChange (date) {
        console.log(date)
      if (date) {
        this.queryParams.printTimeStart = date[0];
        this.queryParams.printTimeEnd = date[1];
      } else {
        this.queryParams.printTimeStart = ''
        this.queryParams.printTimeEnd = ''
      }
    },
    searchReset() {
        this.queryParams.deviceName= undefined;
        this.queryParams.deviceNo=undefined;
        this.queryParams.nickname= undefined;
        this.queryParams.phone= undefined;
        this.queryParams.printTimeStart = undefined;
        this.queryParams.inspect = undefined;
        this.queryParams.problem = undefined;
        this.queryParams.isPrint = undefined;
        this.queryParams.id = undefined;
        this.queryParams.needRecyclingBag = undefined;
    },
    getDataList() {
        const params = {
        pageNo:this.pageNo,
        pageSize: this.pageSize,
        ...this.queryParams
        }
       getTraceCodeRecordList(params).then((res)=>{
        this.list = res.data.records;
        this.total = res.data.total
        })
        },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getDataList();
    },
    // 显示第几页
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getDataList();
    },
    setYesOrNo(val) {
        const item = this.yesOrNo.find((item)=> item.id === val);
        if(item)  return item.value
        return '';  
    },
    setType(val) {
        const item = this.types.find((item)=>item.id === val);
        if(item) return item.value 
        return '';      
    },
    searchQuery () {
      this.getDataList();
    }
      
    },
    
  };
  </script>
  <style lang="scss" scoped>
  .wrapper {
    padding: 20px;
    .el-pagination {
        text-align: right;
    }
    .el-table .el-table__cell {
        text-align: center;
    }
  }
  </style>
  